import { gql } from '@apollo/client';

export const GET_PROFESSIONAL = gql`
  query getProfessional($id: ID!) {
    getProfessional(id: $id) {
      accountStatus
      code
      contactDetail {
        addressPlace
        addressStreet
        addressCountry
        addressPostalCode
        telephoneNumber
      }
      createdAt
      creatorId
      email
      familyName
      firstName
      id
      lastOtpAt
      otpSecret
      twoFactorEnabled
      type
      updatedAt
      user {
        id
        isActive
        language
        timezone
      }
    }
  }
`;

export const GET_PROFESSIONAL_LOGO = gql`
  query getProfessionalLogo($variant: String!) {
    getProfessionalLogo(variant: $variant)
  }
`;

export const GET_PROFESSIONAL_LIST_CLIENTS = gql`
  query professionalListClients($page: Int, $perPage: Int, $filter: ProfessionalListClientFilter) {
    professionalListClients(page: $page, perPage: $perPage, filter: $filter) {
      total
      page
      perPage
      data {
        accountStatus
        actionPlanStatus {
          id
          name
          color
          sorting
          __typename
        }
        addictions {
          id
          addiction {
            id
            name
          }
          __typename
        }
        allergies {
          id
          allergy {
            id
            name
          }
        }
        allergyMisc {
          id
          other
          clientId
          createdAt
          updatedAt
          __typename
        }
        bio {
          id
          sex
          length
          weight
          clientId
          createdAt
          updatedAt
          __typename
          dateOfBirth
          isVegetarian
          clientBioFemale {
            id
            createdAt
            updatedAt
            __typename
            clientBioId
            firstMensAge
            isInMenopause
          }
          waistCircumference
        }
        bloodlineDiseases {
          id
          disease
          clientId
          createdAt
          updatedAt
          __typename
          familyMembers
        }
        careerAndEducationDetail {
          id
          clientId
          createdAt
          updatedAt
          profession
          __typename
          educationLevel
        }
        caregiverContactDetails {
          id
          name
          clientId
          createdAt
          isPrimary
          updatedAt
          __typename
          addressPlace
          relationship
          addressNumber
          addressStreet
          addressCountry
          telephoneNumber
          addressPostalCode
          telephoneCountryCode
        }
        cigaretteConsumption {
          id
          frequency
          createdAt
          clientId
          type
          updatedAt
          __typename
        }
        clientGid
        clientProfilePhotoUrl
        colleagueNotes {
          id
          title
          client {
            id
            email
          }
        }
        createdAt
        email
        emailValidationUrl
        familyDetail {
          id
          type
          clientId
          createdAt
          updatedAt
          fatherName
          motherName
          __typename
          maritalStatus
          numberOfSisters
          numberOfBrothers
          numberOfMaleChildren
          parentsMaritalStatus
          numberOfFemaleChildren
        }
        familyName
        firstName
        foodIntoleranceMisc {
          id
          other
          clientId
          createdAt
          updatedAt
          __typename
        }
        foodIntolerances {
          id
          foodIntolerance {
            id
            name
          }
        }
        foodSupplement {
          id
          content
          clientId
          updatedAt
          createdAt
        }
        gid
        hairAndMineralAnalyses {
          id
          iron
          lead
          zinc
          boron
          cobalt
          copper
          nickel
          adminId
          arsenic
          cadmium
          calcium
          lithium
          mercury
          aluminum
          chromium
          clientId
          hairType
          selenium
          createdAt
          magnesium
          manganese
          potassium
          updatedAt
          molybdenum
          phosphorus
          isSeenByPro
          reportNumber
          attachmentUrl
          clientViewable
          dateOfAnalysis
          professionalViewable
        }
        heartRateVariabilities {
          id
          data
          adminId
          clientId
          createdAt
          updatedAt
          __typename
          isSeenByPro
          reportNumber
          attachmentUrl
          clientViewable
          dateOfAnalysis
          durationOfAnalysis
          specialistReportUrl
          professionalViewable
        }
        id
        importantNotesToProfessional {
          id
          note
          clientId
          createdAt
          updatedAt
          __typename
          yearOfEvent
        }
        involvedHealthProfessionals {
          id
          name
          address
          forWhat
          clientId
          createdAt
          sinceWhen
          updatedAt
          __typename
          telephoneNumber
          telephoneCountryCode
        }
        iodineTests {
          id
          testData {
            id
            adminId
            createdAt
            updatedAt
            __typename
            iodineTestId
            iodideSpotValue
            iodide24hExcretion
            bromideSpotValue
            bromide24hExcretion
            chlorideSpotValue
            chloride24hExcretion
            fluorideSpotValue
            fluoride24hExcretion
            dateOfAnalysis
            reportNumber
          }
          createdAt
          updatedAt
          __typename
          clientViewable
        }
        irCombis {
          id
          crpHs
          glucose
          cPeptide
          clientId
          insuline
          createdAt
          updatedAt
          isDiabetic
          __typename
          isSeenByPro
          homocysteine
          reportNumber
          homa2CInsulin
          homa2CPeptide
          clientViewable
          dateOfAnalysis
          ldlOxAntistoffen
          homa2CInsulinPctB
          homa2CInsulinPctS
          homa2CPeptidePctB
          homa2CPeptidePctS
          professionalViewable
          isSyntheticInsulinUse
        }
        otherHealthProfessionals {
          id
          name
          address
          forWhat
          clientId
          createdAt
          sinceWhen
          updatedAt
          __typename
          telephoneNumber
          telephoneCountryCode
        }
        otherMedication {
          id
          content
          clientId
          __typename
        }
        personalContactDetail {
          id
          clientId
          createdAt
          updatedAt
          __typename
          addressPlace
          addressNumber
          addressStreet
          addressCountry
          telephoneNumber
          addressPostalCode
          telephoneCountryCode
        }
        prescribedMedications {
          id
          content
          clientId
          createdAt
          updatedAt
          __typename
        }
        professionalDocumentUploads {
          id
          title
          client {
            id
            email
          }
          createdAt
          updatedAt
          __typename
          documentUrl
          clientViewable
        }
        professionalHealthComplaintNote {
          id
          tags
          content
          clientId
          createdAt
          updatedAt
          __typename
          attachmentUrls
        }
        professionalLogs {
          id
          title
          client {
            id
            email
          }
          content
          createdAt
          updatedAt
          __typename
          attachmentUrls
          energyLevelVasScore
          clientSummaryAndActions
          generalWellBeingVasScore
          mainHealthProblemVasScore
        }
        questionnaireAssignments {
          client {
            firstName
            familyName
          }
          clientId
          id
          questionnaire {
            closingRemarks
            content
            deactivatedOn
            description
            group
            id
            title
            userId
          }
          questionnaireId
          updatedAt
        }
        requestForHelp {
          id
          clientId
          createdAt
          updatedAt
          __typename
          description
        }
        specialists {
          id
          name
          address
          forWhat
          sinceWhen
          clientId
          createdAt
          updatedAt
          __typename
          telephoneNumber
          telephoneCountryCode
        }
        surgeries {
          id
          when
          forWhat
          clientId
          createdAt
          updatedAt
          __typename
        }
        timelineEvents {
          id
          day
          year
          month
          client {
            id
            email
          }
          content
          createdAt
          updatedAt
          __typename
        }
        timelineTabs {
          id
          name
          color
          client {
            id
            email
          }
          createdAt
          updatedAt
          __typename
        }
        updatedAt
        user {
          id
          isActive
          language
          timezone
          __typename
        }
        vaccinations {
          id
          when
          clientId
          createdAt
          otherName
          updatedAt
          __typename
          vaccination {
            id
            name
          }
          physiologicalResponse
        }
        __typename
      }
    }
  }
`;

export const GET_PROFESSIONAL_LIST_CLIENTS_LIGHT = gql`
  query professionalListClientsLight($page: Int, $perPage: Int, $filter: ProfessionalListClientFilter) {
    professionalListClients(page: $page, perPage: $perPage, filter: $filter) {
      total
      page
      perPage
      data {
        id
        gid
        firstName
        familyName
        email
        accountStatus
        createdAt
      }
    }
  }
`;

export const GET_PROFESSIONAL_CLIENT = gql`
  query getClient($id: ID!) {
    getClient(id: $id) {
      accountStatus
      actionPlanStatus {
        id
        name
        color
        sorting
        __typename
      }
      addictions {
        id
        addiction {
          id
          name
        }
        __typename
      }
      allergies {
        id
        allergy {
          id
          name
        }
      }
      allergyMisc {
        id
        other
        clientId
        createdAt
        updatedAt
        __typename
      }
      bio {
        id
        sex
        length
        weight
        clientId
        createdAt
        updatedAt
        __typename
        dateOfBirth
        isVegetarian
        clientBioFemale {
          id
          createdAt
          updatedAt
          __typename
          clientBioId
          firstMensAge
          isInMenopause
        }
        waistCircumference
      }
      bloodlineDiseases {
        id
        disease
        clientId
        createdAt
        updatedAt
        __typename
        familyMembers
      }
      careerAndEducationDetail {
        id
        clientId
        createdAt
        updatedAt
        profession
        __typename
        educationLevel
      }
      caregiverContactDetails {
        id
        name
        clientId
        createdAt
        isPrimary
        updatedAt
        __typename
        addressPlace
        relationship
        addressNumber
        addressStreet
        addressCountry
        telephoneNumber
        addressPostalCode
        telephoneCountryCode
      }
      cigaretteConsumption {
        id
        frequency
        createdAt
        clientId
        type
        updatedAt
        __typename
      }
      clientGid
      clientProfilePhotoUrl
      colleagueNotes {
        id
        title
        client {
          id
          email
        }
      }
      createdAt
      email
      emailValidationUrl
      familyDetail {
        id
        type
        clientId
        createdAt
        updatedAt
        fatherName
        motherName
        __typename
        maritalStatus
        numberOfSisters
        numberOfBrothers
        numberOfMaleChildren
        parentsMaritalStatus
        numberOfFemaleChildren
      }
      familyName
      firstName
      foodIntoleranceMisc {
        id
        other
        clientId
        createdAt
        updatedAt
        __typename
      }
      foodIntolerances {
        id
        foodIntolerance {
          id
          name
        }
      }
      foodSupplement {
        id
        content
        clientId
        updatedAt
        createdAt
      }
      gid
      hairAndMineralAnalyses {
        id
        iron
        lead
        zinc
        boron
        cobalt
        copper
        nickel
        adminId
        arsenic
        cadmium
        calcium
        lithium
        mercury
        aluminum
        chromium
        clientId
        hairType
        selenium
        createdAt
        magnesium
        manganese
        potassium
        updatedAt
        molybdenum
        phosphorus
        isSeenByPro
        reportNumber
        attachmentUrl
        clientViewable
        dateOfAnalysis
        professionalViewable
      }
      heartRateVariabilities {
        id
        data
        adminId
        clientId
        createdAt
        updatedAt
        __typename
        isSeenByPro
        reportNumber
        attachmentUrl
        clientViewable
        dateOfAnalysis
        durationOfAnalysis
        specialistReportUrl
        professionalViewable
      }
      id
      importantNotesToProfessional {
        id
        note
        clientId
        createdAt
        updatedAt
        __typename
        yearOfEvent
      }
      involvedHealthProfessionals {
        id
        name
        address
        forWhat
        clientId
        createdAt
        sinceWhen
        updatedAt
        __typename
        telephoneNumber
        telephoneCountryCode
      }
      iodineTests {
        id
        testData {
          id
          adminId
          createdAt
          updatedAt
          __typename
          iodineTestId
          iodideSpotValue
          iodide24hExcretion
          bromideSpotValue
          bromide24hExcretion
          chlorideSpotValue
          chloride24hExcretion
          fluorideSpotValue
          fluoride24hExcretion
          dateOfAnalysis
          reportNumber
        }
        createdAt
        updatedAt
        __typename
        clientViewable
      }
      irCombis {
        id
        crpHs
        glucose
        cPeptide
        clientId
        insuline
        createdAt
        updatedAt
        isDiabetic
        __typename
        isSeenByPro
        homocysteine
        reportNumber
        homa2CInsulin
        homa2CPeptide
        clientViewable
        dateOfAnalysis
        ldlOxAntistoffen
        homa2CInsulinPctB
        homa2CInsulinPctS
        homa2CPeptidePctB
        homa2CPeptidePctS
        professionalViewable
        isSyntheticInsulinUse
      }
      otherHealthProfessionals {
        id
        name
        address
        forWhat
        clientId
        createdAt
        sinceWhen
        updatedAt
        __typename
        telephoneNumber
        telephoneCountryCode
      }
      otherMedication {
        id
        content
        clientId
        __typename
      }
      personalContactDetail {
        id
        clientId
        createdAt
        updatedAt
        __typename
        addressPlace
        addressNumber
        addressStreet
        addressCountry
        telephoneNumber
        addressPostalCode
        telephoneCountryCode
      }
      prescribedMedications {
        id
        content
        clientId
        createdAt
        updatedAt
        __typename
      }
      professionalCode
      professionalDocumentUploads {
        id
        title
        client {
          id
          email
        }
        createdAt
        updatedAt
        __typename
        documentUrl
        clientViewable
      }
      professionalHealthComplaintNote {
        id
        tags
        content
        clientId
        createdAt
        updatedAt
        __typename
        attachmentUrls
      }
      professionalLogs {
        id
        title
        client {
          id
          email
        }
        content
        createdAt
        updatedAt
        __typename
        attachmentUrls
        energyLevelVasScore
        clientSummaryAndActions
        generalWellBeingVasScore
        mainHealthProblemVasScore
      }
      questionnaireAssignments {
        client {
          firstName
          familyName
        }
        clientId
        id
        questionnaire {
          closingRemarks
          content
          deactivatedOn
          description
          group
          id
          title
          userId
        }
        questionnaireId
        response {
          id
          type
          answers
          createdAt
          updatedAt
          isSeenByPro
        }
        updatedAt
      }
      requestForHelp {
        id
        clientId
        createdAt
        updatedAt
        __typename
        description
      }
      specialists {
        id
        name
        address
        forWhat
        sinceWhen
        clientId
        createdAt
        updatedAt
        __typename
        telephoneNumber
        telephoneCountryCode
      }
      surgeries {
        id
        when
        forWhat
        clientId
        createdAt
        updatedAt
        __typename
      }
      timelineEvents {
        id
        day
        year
        month
        client {
          id
          email
        }
        content
        createdAt
        updatedAt
        __typename
      }
      timelineTabs {
        id
        name
        color
        client {
          id
          email
        }
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      user {
        id
        isActive
        language
        timezone
        __typename
      }
      vaccinations {
        id
        when
        clientId
        createdAt
        otherName
        updatedAt
        __typename
        vaccination {
          id
          name
        }
        physiologicalResponse
      }
      __typename
    }
  }
`;

export const GET_IRCOMBI_ITEMS = gql`
  query clientIrCombiItems ($clientId: ID!) {
    clientIrCombiItems (clientId:$clientId) {
      createdAt
      id
      reportNumber
      crpHs
      # cPepTide
      glucose
      homa2CInsulin
      homa2CInsulinPctB
      homa2CInsulinPctS
      homa2CPeptide
      homa2CPeptidePctB
      homa2CPeptidePctS
      homocysteine
      insuline
      isDiabetic
      isSeenByPro
      ldlOxAntistoffen
      professionalViewable
      isSyntheticInsulinUse
      clientViewable
    }
  }
`;

export const GET_HRV_ITEMS = gql`
  query clientHrvItems ($clientId:ID!) {
    clientHrvItems (clientId:$clientId) {
      id
      adminId
      clientId
      clientViewable
      data
      dateOfAnalysis
      durationOfAnalysis
      isSeenByPro
      professionalViewable
      reportNumber
      attachmentUrl
      specialistReportUrl
      createdAt
      updatedAt
    }
  }
`;

export const GET_HMA_ITEMS = gql`
  query clientHmaItems ($clientId: ID!) {
    clientHmaItems (clientId:$clientId) {
      id
      adminId
      aluminum
      arsenic
      boron
      cadmium
      calcium
      chromium
      clientId
      clientViewable
      cobalt
      copper
      createdAt
      dateOfAnalysis
      hairType
      iron
      isSeenByPro
      lead
      lithium
      magnesium
      manganese
      mercury
      molybdenum
      nickel
      # phosporus
      potassium
      professionalViewable
      reportNumber
      attachmentUrl
      selenium
      updatedAt
      zinc
    }
  }
`;

export const GET_IODINE_TEST_ITEMS = gql`
  query clientIodineTestItems($clientId: ID!) {
    clientIodineTestItems(clientId: $clientId) {
      id
      createdAt
      updatedAt
      testData {
        iodineTestId
        adminId
        id
        reportNumber
        dateOfAnalysis
        iodideSpotValue
        bromideSpotValue
        chlorideSpotValue
        iodide24hExcretion
        bromide24hExcretion
        chloride24hExcretion
      }
    }
  }
`;

export const GET_CLIENT_TIMELINE_EVENTS = gql`
  query clientTimelineEvents($clientId: ID!) {
    clientTimelineEvents(clientId: $clientId) {
      id
      age
      id
      day
      year
      month
      client {
        firstName
        familyName
      }
      content
      createdAt
      updatedAt
    }
  }
`;

export const GET_CLIENT_QUESTIONNAIRE_LISTS = gql`
  query questionnaireAssignments ($clientId:ID!) {
    questionnaireAssignments (clientId:$clientId) {
      questionnaireId
    	id
    	clientId
      updatedAt
      questionnaire {
        id
        user {
          id
          isActive
          language
          timezone
        }
        group
        title
        userId
        description
        deactivatedOn
        closingRemarks
        # content
      }
    }
  }
`;

export const LIST_PROFESSIONAL_MESSAGES = gql`
  query listProfessionalMessages($clientId: ID!) {
    listProfessionalMessages(clientId: $clientId) {
      page
      perPage
      data {
        content
        isFromClient
        title
        viewed
        id
        clientName
        clientId
        updatedAt
        attachments {
          id
          url
        }
        createdAt
      }
      total
    }
  }
`;

export const GET_PROFESSIONAL_NOTIFICATION = gql`
  query getProfessionalNotifications($professionalCode: ID!) {
    getProfessionalNotifications(professionalCode:$professionalCode) {
      unreadComments
      unreadClientMessages
    }
  }
`;

export const GET_CLIENT_ANALYSIS_REPORT_DOCUMENTS = gql`
  query clientAnalysisReportDocuments($clientId:ID!){
    clientAnalysisReportDocuments (clientId:$clientId) {
      id
      clientId
    }
  }
`;

export const LIST_QUESTIONNAIRES = gql`
  query listQuestionnaires {
    listQuestionnaires {
      id
      name
      title
      groupI18nKey
    }
  }
`;

export const GET_QUESTIONNAIRE_RESPONSE = gql`
  query getQuestionnaireResponse($id: ID!) {
    getQuestionnaireResponse(id: $id) {
      id
      type
      answers
      createdAt
      updatedAt
      isSeenByPro
    }
  }
`;
